import InfoModal from './InfoModal'
import infoModalContainer from './infoModalContainer'

export default infoModalContainer(InfoModal)
